import { API_END_POINTS } from './networks/apiEndPoints';
import api from './networks/api';

export const fetchModulesByRole = async (roleId) => {
  try {
    const response = await api.post(
      API_END_POINTS.GET_MODULES_BY_ROLE,
      { roleId } 
    );

    const data = response.data?.responseData;

    if (!data || !Array.isArray(data) || data.length === 0) {
      throw new Error("No modules returned for this role");
    }

    return data; // array of modules
  } catch (error) {
    console.error("Error fetching modules by role:", error);
    throw error;
  }
};
